<script setup lang="ts"></script>

<template>
  <div class="order:tw-pb-16 order:-tw-mx-8 tw-mr-0 tw-flex tw-justify-center tw-gap-4 tw-pb-80">
    <div class="order:tw-flex-1 order:tw-pl-8 tw-mx-auto tw-w-full tw-max-w-[1100px]">
      <slot name="main"></slot>
    </div>
    <slot name="summary"></slot>
  </div>
</template>
